<div class="container-fluid admin-form-page edit-entity-page">
  <div class="row section1 align-items-center">
    <div class="col-12 col-md-7 col-lg-7 col-xl-7">
      <div class="home-details">
        <h5 class="home-title">
          Edit Entity details
        </h5>
        <p class="home-subtitle">Fill all the below fields </p>
      </div>
    </div>
    <div class="col-12 col-md-7 col-lg-5 col-xl-5">
      <div class="dashboard-btn dashboard-manage admin-page-actions edit-entity-actions">
        <button type="submit"
          form="editEntityForm"
          [disabled]="isSubmitting || uploading"
        class="btn btn-primary btn-dashboard">{{isSubmitting ? 'Saving...' : 'Save Changes'}}</button>
        <button type="button" (click)="utils.goBack()" class="btn btn-primary btn-dashboard">Back</button>
      </div>
    </div>
  </div>
  @if (entity) {
    <div class="section1">
      <div class="applicants-details details1 admin-form-card">
        <form class="admin-form" id="editEntityForm" (ngSubmit)="updateEntity()" >
          <section class="form-section">
            <h5 class="section-title">Basic Info</h5>
            <div class="row align-items-center">
              <div class="col-12 col-lg-2">
                <div class="user-form">
                  <div class="form-group d-flex flex-column">
                    <label class="text-nowrap">Choose Profile*</label>
                    @if (entity.image) {
                      <img class="position-relative rounded-circle"
                        style="object-fit: cover" width="100" height="100"
                        src="{{entity.image}}" alt="">
                    }
                    @if (!entity.image) {
                      <img class="position-relative rounded-circle"
                        style="object-fit: cover" width="100"
                        height="100"
                        src="assets/images/placeholder.png" alt="">
                      }
                      @if (!entity.image && !uploading) {
                        <i (click)="handleClickUpload()"
                        class="las font-size-16 la-plus-circle img-icon"></i>
                      }
                      @if (entity.image && !uploading) {
                        <i (click)="handleClickUpload()"
                        class="las font-size-16 la-pencil-alt img-icon"></i>
                      }
                      @if (uploading) {
                        <div class="img-icon-loader">
                          <img src="assets/images/loading.gif" width="40" alt="">
                        </div>
                      }
                    </div>
                    <input id="dp_entity" name="file-upload-field" type="file"
                      accept=".png, .jpg, .jpeg, .webp"
                      class="form-control d-none"
                      (change)="fileChangeEvent($event, imageCropperModal)">
                  </div>
                </div>
                <div class="col-12 col-lg-4">
                  <div class="user-form">
                    @if (entity) {
                      <div class="form-group">
                        <label for="firstName">First Name*</label>
                        <input type="text" class="form-control" id="firstName" [(ngModel)]="entity.firstName"
                          name="firstName" placeholder="Enter First Name">
                      </div>
                    }
                  </div>
                </div>
                <div class="col-12 col-lg-4">
                  <div class="user-form">
                    @if (entity) {
                      <div class="form-group">
                        <label for="lastName">Last Name</label>
                        <input type="text" class="form-control" id="lastName" [(ngModel)]="entity.lastName"
                          name="lastName" placeholder="Enter Last Name">
                      </div>
                    }
                  </div>
                </div>
                <div class="col-12 col-lg-2">
                  <div class="user-form">
                    @if (entity) {
                      <div class="form-group">
                        <label for="entityCategory">Category*</label>
                        <input type="text" class="form-control" id="entityCategory" [(ngModel)]="entity.category.categoryName"
                          name="entityCategory" placeholder="Enter Category Name" disabled>
                      </div>
                    }
                  </div>
                </div>
                <div class="col-12 col-lg-4">
                  <div class="user-form">
                    @if (entity) {
                      <div class="form-group">
                        <label for="entityIsPerson">Is person*</label>
                        <select class="form-control" id="entityIsPerson" [(ngModel)]="entity.in_person"
                          name="entityIsPerson">
                          <option value=true>Yes</option>
                          <option value=false>No</option>
                        </select>
                      </div>
                    }
                  </div>
                </div>
                <div class="col-12 col-lg-4">
                  <div class="user-form">
                    @if (entity) {
                      <div class="form-group">
                        <label for="entityIsPerson">Is followable*</label>
                        <select class="form-control" id="isFollowable" [(ngModel)]="entity.allow_bhakt" name="followable">
                          <option value=true>Yes</option>
                          <option value=false>No</option>
                        </select>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </section>
            @if (entity?.infoData?.informativeParameters?.length) {
              <section class="form-section">
                <h5 class="section-title">Informative Data</h5>
                <!--          <div class="row">-->
                <!--            <div class="col-12 col-lg-3  col-xl-3 form-details"-->
                <!--                 *ngFor="let info of informative; let i = index">-->
                <!--              <div class="user-form">-->
                <!--                <div class="form-group">-->
                <!--                  <label>{{info.fieldName}}</label>-->
                <!--                  <div [ngSwitch]="info.fieldType">-->
                <!--                    <div *ngSwitchCase="'text'">-->
                <!--                      <input type="text" class="form-control" [name]="info.id" [required]="info.isRequired"-->
                <!--                             [(ngModel)]="informative[i].value" [id]="info.id" [placeholder]="info.fieldName">-->
              <!--                    </div>-->
              <!--                    <div *ngSwitchCase="'date'">-->
              <!--                      <input type="date" class="form-control" [name]="info.id" [placeholder]="info.fieldName"-->
              <!--                             [required]="info.isRequired" [(ngModel)]="informative[i].value" [id]="info.id">-->
            <!--                    </div>-->
            <!--                    <div *ngSwitchCase="'text-area'">-->
            <!--                      <angular-editor [placeholder]="info.fieldName" rows="6" [name]="info.id" [config]="editorConfig"-->
            <!--                                      [(ngModel)]="informative[i].value" [required]="info.isRequired" [id]="info.id">-->
          <!--                      </angular-editor>-->
        <!--                    </div>-->
      <!--                  </div>-->
    <!--                </div>-->
  <!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<div class="row">
  @for (info of entity?.infoData?.informativeParameters; track info; let i = $index) {
    <div class="col-12 form-details1">
      <div class="user-form">
        <div class="form-group">
          <label>{{info.fieldName + (info.isRequired ? '*' : '')}}</label>
          <div>
            @switch (info.fieldType) {
              @case ('text') {
                <div>
                  <input type="text" class="form-control" [name]="info.id + i + 'text'"
                    [(ngModel)]="info['value']" [required]="info.isRequired"
                    placeholder="{{info.fieldName}}">
                </div>
              }
              @case ('date') {
                <div>
                  <input type="date" class="form-control" [name]="info.id + i + 'data'" [required]="info.isRequired"
                    [(ngModel)]="info['value']" [id]="info.id"
                    [placeholder]="info.fieldName">
                </div>
              }
              @case ('text-area') {
                <div>
                  <angular-editor [placeholder]="info.fieldName" [config]="editorConfig" rows="6"
                    [name]="info.id + i + 'text-area'" [(ngModel)]="info['value']"
                  [required]="info.isRequired" [id]="info.id"></angular-editor>
                </div>
              }
              @case ('lookUp') {
                <div>
                  @if (info['metadata']) {
                    <ng-select class="custom"
                      [(ngModel)]="info['metadata']['name']"
                      [name]="'lookUp'+info.fieldName"
                      [id]="'lookUp'+info.fieldName"
                      (change)="handleSelectInfo($event, i)"
                      [notFoundText]="'No '+ info.fieldName + ' found'"
                      [placeholder]="'Select ' + info.fieldName "
                      [clearable]="false"
                      appendTo="body">
                      @for (e of filterEntities(info.fieldName); track e) {
                        <ng-option
                        [value]="{id: e.id, slug: e.slug, name: e.firstName + ' ' + e.lastName}">{{e.firstName}} {{e.lastName}}</ng-option>
                      }
                    </ng-select>
                  }
                </div>
              }
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>
</section>
}
<section class="form-section">
  <div class="col-12 user-form  px-0">
    <div class="">
      <h5 class="section-title">Accessibility</h5>
    </div>
    <div class="row">
      @for (x of entity?.allowedUserActions | keyvalue; track x; let xi = $index) {
        <div class="col-auto">
          <label class="mr-2">{{x.key}}</label>
          <input type="checkbox" [ngModel]="entity?.allowedUserActions?.[x.key]"
            (ngModelChange)="onAllowedUserActionChange(x.key, $event)" name="checkboxName-{{xi}}"
            id="checkboxId-{{xi}}">
        </div>
      }
    </div>
  </div>
</section>
@if (entity?.subjectiveData?.value?.length) {
  <section class="form-section user-form">
    <h5 class="section-title">Subjective Data</h5>
    <div class="col-md-12">
      <div class="row">
        @for (s of entity?.subjectiveData.value; track s; let si = $index) {
          <div class="col-12 ml-0 pl-0"
            >
            <div class="user-form">
              <div class="form-group">
                <span class="badge badge-secondary p-2 my-2 mr-2">{{s.field.fieldName}}</span>
                <angular-editor [(ngModel)]="s.value" [config]="editorConfig" [name]="s.id + si + 'sub'"
                [id]="s.id" attr.placeholder="Enter {{s.field.fieldName}}"></angular-editor>
              </div>
            </div>
          </div>
        }
        @if (entity?.subjectiveData?.value?.length == 0) {
          <div>N/A</div>
        }
      </div>
    </div>
  </section>
}
@if (entities) {
  <section class="form-section user-form">
    <h5 class="section-title">Related Entities</h5>
    <div class="form-group">
      <mat-chip-set class="entity-chip-list">
        @for (e of relatedEntities; track e) {
          <mat-chip class="entity-chip" color="primary">{{e.name ? e.name : e.entityName}}
            <mat-icon class="entity-chip-remove" (click)="removeEntity(e.id)">cancel</mat-icon>
          </mat-chip>
        }
      </mat-chip-set>
      <div class=" mt-3">
        <ng-select class="custom"
          [(ngModel)]="selectedRelatedEntities"
          name="relatedEntity"
          id="relatedEntity"
          (change)="toggleEntity($event)"
          notFoundText="No entity found"
          placeholder="Select entity"
          [clearable]="false"
          appendTo="body">
          @for (e of filterRelatedEntities(); track e) {
            <ng-option
            [value]="e.id">{{e.firstName}} {{e.lastName}}</ng-option>
          }
        </ng-select>
      </div>
    </div>
  </section>
}
@if (entities) {
  <section class="form-section user-form">
    <h5 class="section-title">Child Entities</h5>
    <div class="form-group">
      <mat-chip-set class="entity-chip-list">
        @for (e of childEntities; track e) {
          <mat-chip class="entity-chip" color="primary">{{e.name ? e.name : e.entityName}}
            <mat-icon class="entity-chip-remove" (click)="removeEntity(e.id, true)">cancel</mat-icon>
          </mat-chip>
        }
      </mat-chip-set>
      <div class=" mt-3">
        <ng-select class="custom"
          [(ngModel)]="selectedChildEntities"
          name="childEntity"
          id="childEntity"
          (change)="toggleEntity($event, true)"
          notFoundText="No entity found"
          placeholder="Select entity"
          [clearable]="false"
          appendTo="body">
          @for (e of filterRelatedEntities(true); track e) {
            <ng-option
            [value]="e.id">{{e.firstName}} {{e.lastName}}</ng-option>
          }
        </ng-select>
      </div>
    </div>
  </section>
}
</form>
</div>
</div>
}
</div>


<ng-template #imageCropperModal>
  <div class="modal-header">
    <h5 class="modal-title">Profile image</h5>
    <button type="button" class="close " data-dismiss="modal" aria-label="Close" (click)="closeCropperModal()" [disabled]="uploading">
      <span aria-hidden="true" class="">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <image-cropper
      (imageCropped)="imageCropped($event)"
      (loadImageFailed)="loadImageFailed()"
      output="blob"
      [aspectRatio]=aspectRatio
      [imageChangedEvent]="imageChangedEvent"
      [maintainAspectRatio]="true"
      format="png">
    </image-cropper>
  </div>
  <div class="modal-footer justify-content-end">
    <button type="button" class="btn btn-default mr-2" data-dismiss="modal" (click)="closeCropperModal()" [disabled]="uploading">Close</button>
    <button (click)="uploadImage()" class="btn btn-primary btn-dashboard" type="button" [disabled]="uploading">
      {{uploading ? 'Uploading...' : 'Crop'}}
    </button>
  </div>
</ng-template>
